import { render, staticRenderFns } from "./CatchCuttingOrder.vue?vue&type=template&id=4740a542&scoped=true"
import script from "./CatchCuttingOrder.vue?vue&type=script&lang=js"
export * from "./CatchCuttingOrder.vue?vue&type=script&lang=js"
import style0 from "./CatchCuttingOrder.vue?vue&type=style&index=0&id=4740a542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4740a542",
  null
  
)

export default component.exports